<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="funcRoute(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <template>
          <img :src="imgUrl" width="100%" />
        </template>
        <CRow
          class="mt-3 mb-3 ml-5 mr-5"
          alignHorizontal="center"
          alignVertical="center"
        >
          <h5 :class="checkLangClass() + ' ' + 'Topic'">
            {{ checkLanguage(cardContent.content.description) }}
          </h5>
        </CRow>

        <CRow
          alignVertical="center"
          alignHorizontal="center"
          class="BTNNextPrev"
        >
          <div class>
            <CButton
              @click="funcBackRoute(cardContent.navigate.previous.action)"
              class="ButtonCustomLeft"
              block
              color="danger"
              shape="pill"
              size="lg"
              >PREV</CButton
            >
          </div>
          <div class>
            <CButton
              @click="funcRoute(cardContent.navigate.next.action)"
              class="ButtonCustomRight"
              block
              color="success"
              shape="pill"
              size="lg"
              >NEXT</CButton
            >
          </div>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import CardIntroComponent from "./CardIntroComponent";
import "../../../assets/scss/_chineseStyle.scss";
import "../../../assets/scss/_chineseIcon.scss";
import infoTranparent from "./InfoTranparent";
import TextComponent from "./TextComponent";
import { mapGetters } from "vuex";
export default {
  components: {
    infoTranparent,
    CardIntroComponent,
    TextComponent,
  },
  props: { cardContent: Object },
  name: "CardImageSquare",
  data() {
    return {
      lang: "",
      imgUrl: "",
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },

  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },

  watch: {
    getLanguage: function(val) {
      this.lang = val;
    },
    cardContent: function(val) {
      if (val) {
        this.imgUrl = this.baseUrl + val.content.item[0].data;
      }
    },
  },

  mounted() {
    //
  },

  created() {
    this.lang = this.$store.state.language.language;
    this.imgUrl = this.baseUrl + this.cardContent.content.item[0].data;
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    funcBackRoute(tempId) {
      var player = document.getElementsByClassName("IconAudio");
      let str = tempId.split("-");
      this.$store.commit("necessary/setCodePage", str[1]);
      let body = "/" + str[0] + "/" + str[1];
      this.$router.push(body);
    },
    funcRoute(tempId) {
      var player = document.getElementsByClassName("IconAudio");
      this.$emit("nextRoute", tempId);
    },
  },
};
</script>

<style>
.BTNNextPrev {
  padding-top: 5%;
}
.ButtonCustomLeft {
  margin-right: 20px;
}
.ButtonCustomRight {
  margin-left: 20px;
}
/* .ImageLesson {
  width: 10% !important;
  height: 399px;
  position: relative;
} */
</style>
